import cx from 'classnames';
import PropTypes from 'prop-types';

import { IconPen16 } from 'src/assets/icons/16x16/IconPen16';
import { IconDelete } from 'src/assets/icons/IconDelete';
import { CustomButtonBase } from 'src/components/CustomButtonBase';
import {
  CUSTOM_ICON_BUTTON_SIZE,
  CUSTOM_ICON_BUTTON_VARIANT,
  CustomIconButton,
} from 'src/components/CustomIconButton';
import { TruncatedTypography, TYPOGRAPHY_VARIANT } from 'src/components/TruncatedTypography';

import { CardImages } from './components/CardImages';
import { useStyles } from './useStyles';

const propTypes = {
  className: PropTypes.string,
  imageStyle: PropTypes.shape().isRequired,
  visualLanguage: PropTypes.shape(),
  onClick: PropTypes.func,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
};
const defaultProps = {
  className: '',
  onClick: null,
  onEdit: null,
  onDelete: null,
  visualLanguage: null,
  selected: false,
  disabled: false,
};

export const ImageStyleCard = ({
  className,
  imageStyle,
  visualLanguage,
  onClick,
  onEdit,
  onDelete,
  selected,
  disabled,
}) => {
  const styles = useStyles();

  return (
    <div
      className={cx(styles.root, className, {
        [styles.selected]: selected,
      })}
    >
      <CustomButtonBase
        className={styles.content}
        onClick={onClick}
        disabled={disabled}
      >
        <CardImages
          className={styles.cardImages}
          images={imageStyle.referenceImagesList}
        />

        <TruncatedTypography
          className={styles.title}
          variant={TYPOGRAPHY_VARIANT.semiBold12}
        >
          {imageStyle.name}
        </TruncatedTypography>
      </CustomButtonBase>

      <div className={styles.actions}>
        {onEdit && (
          <CustomIconButton
            className={styles.editButton}
            onClick={onEdit}
            disabled={disabled}
            variant={CUSTOM_ICON_BUTTON_VARIANT.outlined}
            size={CUSTOM_ICON_BUTTON_SIZE.small}
          >
            <IconPen16 />
          </CustomIconButton>
        )}

        {onDelete && (
          <CustomIconButton
            className={styles.deleteButton}
            onClick={onDelete}
            disabled={disabled}
            variant={CUSTOM_ICON_BUTTON_VARIANT.outlined}
            size={CUSTOM_ICON_BUTTON_SIZE.small}
          >
            <IconDelete />
          </CustomIconButton>
        )}
      </div>

      {visualLanguage && (
        <div className={styles.footer}>
          <TruncatedTypography
            className={styles.visualLanguageName}
            variant={TYPOGRAPHY_VARIANT.regular12}
          >
            {visualLanguage.name}
          </TruncatedTypography>
        </div>
      )}
    </div>
  );
};
ImageStyleCard.displayName = 'ImageStyleCard';
ImageStyleCard.propTypes = propTypes;
ImageStyleCard.defaultProps = defaultProps;
